import { FunctionComponent } from 'react'

import NetInfo from '@react-native-community/netinfo'
import * as Notifications from 'expo-notifications'
import { Platform } from 'react-native'
import { enableFreeze } from 'react-native-screens'
import { onlineManager } from 'react-query'
import { BrowserRouter } from 'react-router-dom'

import { AppProviders } from './AppProviders'
import { RootStackNavigator } from './navigation'

enableFreeze(true)

// Handler to enable notications
Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: false,
    shouldSetBadge: false
  })
})

/**
 * Reference: https://react-query.tanstack.com/react-native#online-status-management
 */
onlineManager.setEventListener((setOnline) => {
  return NetInfo.addEventListener((state) => {
    setOnline(!!state.isConnected)
  })
})

export const App: FunctionComponent = () => {
  const isWeb = Platform.OS === 'web'

  return isWeb ? (
    <BrowserRouter>
      <AppProviders>
        <RootStackNavigator />
      </AppProviders>
    </BrowserRouter>
  ) : (
    <AppProviders>
      <RootStackNavigator />
    </AppProviders>
  )
}
